module.exports = __webpack_public_path__ + "media/newstyle/images/publish-book-ca49ba25f9e5bb257b90be3b5dfd8372.png";